import { render, staticRenderFns } from "./integrationConsults.vue?vue&type=template&id=c78f2282&scoped=true&"
import script from "./integrationConsults.vue?vue&type=script&lang=js&"
export * from "./integrationConsults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c78f2282",
  null
  
)

export default component.exports